// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__18Afh","left":"InfoRow_left__uAcYu"};